module.exports = __webpack_public_path__ + "img/9466c5e7-ad13-4563-83fc-389ce3ac21f6.1bc8219d.png";